import type { NextPage } from 'next'

import { SanityContentPage } from 'src/components/layouts/Page/SanityContentPage'

const Registries: NextPage = () => <SanityContentPage slug='registries' />

export default Registries
